import { ShopifyConverter } from "./functions/shopifyConverter";
import { Bigcommerce } from "./functions/bigcommerce";
function convertCurrency(platform, price, current) {
    if (platform === "Shopify") {
        return ShopifyConverter.convert(price, current);
    }
    return { price, currency: current };
}
function getCurrentCurrency(platform) {
    if (platform === "BigCommerce") {
        return Bigcommerce.getBCCurrentCurrency();
    }
    return null;
}
export { convertCurrency, getCurrentCurrency };
//# sourceMappingURL=main.js.map